module.exports = __webpack_public_path__ + "static/media/hall-P12.cf440f2a.svg";